<template>
  <div>
    <a-row>
      <a-col
        v-for="(item, bill) in itemBillStd"
        :key="'bill' + bill"
        :xs="24"
        :sm="24"
        :md="{ span: 8, offset: 1 }"
        :lg="{ span: 6, offset: 1 }"
        :xl="{ span: 6, offset: 1 }"
      >
        <div class="gutter-box">
          
          <a-card hoverable class="mb-20">
            <img
              slot="cover"
              alt="imag_fee_std_1"
              class="img-qr"
              :src="ImageQrPayment(item.qrcode)"
            />
            <!-- content -->
            <a-list class="demo-loadmore-list" item-layout="horizontal">
              <!-- app name -->
              <a-list-item>
                <div>
                  <h6>Detail</h6>
                  <p class="mt-0 mb-0">{{ item.bill_type_detail.appname }}</p>
                  <p class="mt-0 mb-0">{{ item.bill_type_detail.appdetail }}</p>
                  <p class="mt-0 mb-0">Ref 1 : {{ item.ref_1 }}</p>
                  <p class="mt-0 mb-0">Ref 2 : {{ item.ref_2 }}</p>
                </div>
              </a-list-item>
              <!-- app name -->
              <a-list-item>
                <div>Status</div>
                <div>
                  <a-tag :color="item.status === 'paid' ? 'green' : 'blue'">
                    {{ item.status === "creating" ? "Awaiting" : item.status }}
                  </a-tag>
                </div>
              </a-list-item>
              <!-- Await & create -->
              <div v-if="item.status !== 'paid'">
                <a-list-item>
                  <div>Payment deadline</div>
                  <div>
                    {{ moment(item.expire_date).format("DD / MM / YYYY") }}
                  </div>
                </a-list-item>
                <a-list-item>
                  <div>Amount to be paid</div>
                  <div>
                    <h5 class="mt-0 mb-0">฿ {{ item.sum_price }}</h5>
                    <p class="mt-0 mb-0">Baht</p>
                  </div>
                </a-list-item>
              </div>
              <!-- success Only -->
              <div v-if="item.status === 'paid'">
                <a-list-item>
                  <div class="text-muted">Receipt ID</div>
                  <div class="font-bold">{{ item.receipt_id }}</div>
                </a-list-item>
                <a-list-item>
                  <div class="text-muted">Payer name</div>
                  <div class="font-bold">{{ item.payer_name }}</div>
                </a-list-item>
                <a-list-item>
                  <div class="text-muted">Sending Bank</div>
                  <div style="font-size: 12px" class="font-bold">
                    {{ item.sending_bank }}
                  </div>
                </a-list-item>
                <a-list-item>
                  <div class="text-muted">Transaction Timestamp</div>
                  <div class="font-bold">
                    <p class="mt-0 mb-0">
                      {{
                        moment(item.transaction_date_time).format("DD/MM/YYYY")
                      }}
                    </p>
                    <p class="mt-0 mb-0 f-12">
                      {{ moment(item.transaction_date_time).format("LT") }}
                    </p>
                  </div>
                </a-list-item>
                <a-list-item>
                  <div class="text-muted">Paid Amount</div>
                  <div>
                    <h5 class="mt-0 mb-0">฿ {{ item.payer_amount }}</h5>
                    <p class="mt-0 mb-0">Baht</p>
                  </div>
                </a-list-item>
              </div>
            </a-list>
          </a-card>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      feeLoad: false,
      itemBillStd: [],
    };
  },
  mounted() {
    this.getFeeStudent();
  },
  methods: {
    ImageQrPayment(val) {
      return val !== null ? `data:image/jpg;base64,${val}` : null;
    },
    async getFeeStudent() {
      this.itemBillStd = [];
      try {
        const res = await this.$http.get("/ic-payment/me/");
        if (res.status === 200) {
          this.itemBillStd = res.data;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {}
    },
  },
};
</script>

<style scoped>
.img-qr {
  padding: 20px;
}
</style>